class RequestList {
    constructor(){
        this.filters = [];
        this.orders = [];
        this.page = null;
        this.count = null;
    }
    setOrders(orders){
        orders = orders || [];

        orders.forEach(order => {
            this.addOrder(order.column_name, order.value)
        })
    }
    setFilters(filters){
        filters = filters || [];

        filters.forEach(filter => {
            this.addFilter(filter.column_name, filter.operand, filter.value || null)
        })
    }
    addFilter(column_name, operand, value){
        this.filters.push({
            column_name,
            operand,
            value
        });
    }
    addOrder(column_name, value){
        this.orders.push({
            column_name,
            value
        })
    }
    setPage(page, count){
        this.page = page;
        this.count = count
    }
    json(){
        let params = {
            filters : {},
            orders : {},
            page : this.page,
            count : this.count
        };
        if(this.filters){
            this.filters.forEach((filter, index)=>{
                params.filters[index] = filter;
            });
        }
        if(this.orders){
            this.orders.forEach((order, index)=>{
                params.orders[index] = order;
            });
        }
        return params;
    }
}
export default RequestList